<template>
  <div class="hello">
    <div class="foote" ref="foote">
      <div class="banner">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
       <!-- <img src="https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1597798406&di=99ea1c9a39380a861458739822b88656&src=http://bpic.588ku.com/back_pic/00/03/46/05561e73254317d.jpg"
          alt=""> -->
          <swiper class="myswiper swiper-no-swiping" :options="swiperOption" ref="mySwiper">
            <swiper-slide class="swiper-slide " v-for="(item,index) in carouselArrs" :key="index" @click.native="rute(item.goods_id)">
               <img style="height: 516px; width: 100%;" :src=" item.banner_pic" alt="">
            </swiper-slide>
            <!-- 分页器 -->
            <div class="hp_scroll" ref="hpScroll"  style="height: 25%;">
            </div>
          </swiper>
      </div>
      <div class="banner1 marB">
        <div class="leftVideo">
          <video v-if="video" :src="video.video_src" controls="controls"></video>
        </div>
        <div class="rightMain">
          <div class="rightTop">
            <div class="mainList" v-for="(item,index) in mainList" :key="index" @click="detail(item)" v-if="index < 3">
              <div class="mainImage">
                 <img :src="item.pic" alt="">
              </div>
              <div class="mainBottom">
                <p class="mainTitle">{{item.category_name}}</p>
                <div class="genduo" >
                     查看更多
                </div>
              </div>
            </div>
           <!-- <div class="mainList">
             <div class="mainImage">
                 <img src="../assets/image/main.png" alt="">
              </div>
            </div>
            <div class="mainList">
              <div class="mainImage">
                  <img src="../assets/image/main3.png" alt="">
               </div>
            </div> -->
          </div>
          <div class="allBtn" @click="allData()">
            查看更多
          </div>
        </div>
      </div>
      <fiex :shows="fixed" :fatherMethod="goTop" ></fiex>
      <div style="height: 223px;"></div>
    </div>
  </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  export default{
    components:{
      fiex
    },
    data(){
      return{
        fixed:true,
        mainList:[
            {
              cover_img:require('../assets/image/main1.png'),
              name:'画廊'
            },
            {
              cover_img:require('../assets/image/main.png'),
              name:'周边'
            },
            {
              cover_img:require('../assets/image/main3.png'),
              name:'书籍'
            }
        ],
        video:{},
        carouselArrs:[ ],
        swiperOption: {
          //设置点击箭头
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //自动轮播
          autoplay: 3000,
          //开启循环模式
          // loop: true
        },
      }
    },
    created(){
      var that= this;
      this.$fetch('/goods/categoryList').then(res=>{
         that.carouselArrs =res.data.banner;
         console.log(that.carouselArrs);
         that.mainList = res.data.category;
         console.log(res);
         that.video = res.data.video;
      })
    },
    methods:{
      rute(id){
        this.$router.push({
          path:'/detail',
          query:{
            id:id
          }
        })
      },
      allData(){
        this.$router.push({
          path:'/shopDetail',
          query:{
            category_id:0
          }
        })
      },
      goTop(){
        this.$refs.foote.scrollTop = 0;
      },
      detail(item){

        this.$router.push({
          path:'/shopDetail',
          query:{
            category_id:item.category_id
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/ShoppingMall.css");
</style>



// WEBPACK FOOTER //
// src/pages/ShoppingMall.vue